import { ScopeChangeRequestStatus } from './ScopeChangeRequest'
import { match } from 'utils/pattern-match-util'

/**
 * Query string builder for the Scope Change Request Search API.
 */
export default class ScopeChangeRequestQueryBuilder {
  statuses = ''

  /**
   * Searches for scope change requests with any status.
   *
   * @param statuses
   * @returns
   */
  withStatuses(
    statuses?: ScopeChangeRequestStatus[]
  ): ScopeChangeRequestQueryBuilder {
    if (!statuses) {
      return this
    }

    this.statuses += statuses
      .map((s) => condition('status', '=', toScopeChangeRequestStatus(s)))
      .join(' OR ')
    return this
  }

  /**
   * Builds the query string.
   *
   * @returns
   */
  build(): string {
    return this.statuses
  }
}

/**
 * Generates a condition and escapes the passed value.
 *
 * @param field
 * @param operator
 * @param value
 * @returns
 */
function condition(
  field: string,
  operator: ConditionOperator,
  value: any
): string {
  // eslint-disable-next-line no-useless-escape
  return `${field}${operator}\"${value}\"`
}

type ConditionOperator = '=' | '>' | '<' | '>=' | '<=' | ':'

function toScopeChangeRequestStatus(status: ScopeChangeRequestStatus) {
  return match<ScopeChangeRequestStatus, string>(status, {
    [ScopeChangeRequestStatus.PendingFinalization]: () => 'PendingFinalization',
    [ScopeChangeRequestStatus.PendingAdminApproval]: () =>
      'PendingAdminApproval',
    [ScopeChangeRequestStatus.PendingClientApproval]: () =>
      'PendingClientApproval',
    [ScopeChangeRequestStatus.Accepted]: () => 'Accepted',
    [ScopeChangeRequestStatus.Rejected]: () => 'Rejected',
    [ScopeChangeRequestStatus.Unspecified]: () => '',
  })
}
